// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ypmennmpmhttnsgeviul.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlwbWVubm1wbWh0dG5zZ2V2aXVsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDEzNzY1MDQsImV4cCI6MjA1Njk1MjUwNH0.t92C9cQj0F8JQaw6_3x4zDvioXb2tz6C_i6b6ON8Ju8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);